"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DemoHero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: subtitleRef,
    isVisible: subtitleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-fixed bg-cover bg-center bg-no-repeat" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1515015/img/hero_clearconnect_ai_receptionist.png)"
    }}>
        <div className="absolute inset-0 bg-gradient-to-br from-primary/70 to-secondary/60" />
      </div>

      {}
      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        {}
        <h1 ref={headlineRef} className="font-display font-bold text-white mb-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] opacity-100 translate-y-0 !text-4xl md:!text-5xl">Erleben Sie ihren&nbsp; Virtuellen Rezeptionisten JETZT in Aktion</h1>

        {}
        <p ref={subtitleRef} className={`text-xl sm:text-2xl md:text-3xl text-white/95 mb-10 max-w-2xl mx-auto transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] delay-100 ${subtitleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[0.625rem]"}`}>
          Sehen Sie, wie unsere intelligente KI automatisch Anrufe entgegennimmt, Termine bucht und Kundenanfragen bearbeitet – rund um die Uhr.
        </p>

        {}
        <div ref={ctaRef} className={`inline-block transition-all duration-[var(--duration-medium)] ease-[var(--ease-out)] delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[0.625rem]"}`}>
          <div className="inline-block bg-white/10 backdrop-blur-md rounded-lg p-2 shadow-medium transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] hover:scale-[1.02] hover:shadow-strong">
            <Button asChild size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover active:bg-primary-active shadow-soft px-8 py-4 text-lg sm:text-xl font-semibold rounded-md transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)] focus-ring">
              <Link to="/DemoPage">Kostenloses Demo sehen</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}